import { integrationConstants as ic } from 'srcReact/Pages/IntegrationSettings/constants'
import { commonActions } from 'srcReact/components'
import { generalService } from 'srcReact/services'
import { integrationService } from 'srcReact/services/integrationService'

export const integrationActions = {
  getAvailableOrgConnections,
  getExternalAPIConnection,
  saveExternalAPIToken,
  setDefaultAddToCalendar,
  setDefaultVirtualMeeting,
  getActiveIntegrations,
  getAllActiveIntegrations,
  revokeToken,
  postEventToCalendar,
  addToCalendarWithoutConnection,
  openCalendarModal,
  closeCalendarModal,
  setGoogleTranslationKey,
  updateIntegrations,
  clearData
}

function getAvailableOrgConnections(organizationId) {
  return (dispatch) => {
    dispatch(request({ organizationId }))

    integrationService.getAvailableOrgConnections(organizationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.GET_AVAIL_ORG_CONN_REQUEST, response }
  }
  function success(response) {
    return { type: ic.GET_AVAIL_ORG_CONN_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.GET_AVAIL_ORG_CONN_FAILURE, error }
  }
}

function getExternalAPIConnection(type, organizationId, authToken = null) {
  return (dispatch) => {
    dispatch(request({ type, organizationId }))

    integrationService.getExternalAPIConnection(type, organizationId, authToken).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.GET_EXTERNAL_API_CONNECTION_REQUEST, response }
  }
  function success(response) {
    return { type: ic.GET_EXTERNAL_API_CONNECTION_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.GET_EXTERNAL_API_CONNECTION_FAILURE, error }
  }
}

function saveExternalAPIToken(
  type,
  code,
  setUseForCalendar,
  setUseForMeeting,
  setAddToCalendarDefault,
  setMeetingDefault,
  organizationId
) {
  return (dispatch) => {
    dispatch(
      request({
        type,
        code,
        setUseForCalendar,
        setUseForMeeting,
        setAddToCalendarDefault,
        setMeetingDefault,
        organizationId
      })
    )

    integrationService
      .saveExternalAPIToken(
        type,
        code,
        setUseForCalendar,
        setUseForMeeting,
        setAddToCalendarDefault,
        setMeetingDefault,
        organizationId
      )
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(response) {
    return { type: ic.SAVE_EXTERNAL_API_TOKEN_REQUEST, response }
  }
  function success(response) {
    return { type: ic.SAVE_EXTERNAL_API_TOKEN_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.SAVE_EXTERNAL_API_TOKEN_FAILURE, error }
  }
}

function setDefaultAddToCalendar(calendarType, organizationId, authToken) {
  return (dispatch) => {
    dispatch(request())

    integrationService.setDefaultAddToCalendar(calendarType, organizationId, authToken).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.SET_DEFAULT_ADD_TO_CALENDAR_REQUEST, response }
  }
  function success(response) {
    return { type: ic.SET_DEFAULT_ADD_TO_CALENDAR_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.SET_DEFAULT_ADD_TO_CALENDAR_FAILURE, error }
  }
}

function setDefaultVirtualMeeting(meetingType, organizationId, authToken) {
  return (dispatch) => {
    dispatch(request())

    integrationService.setDefaultVirtualMeeting(meetingType, organizationId, authToken).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.SET_DEFAULT_VIRTUAL_MEET_REQUEST, response }
  }
  function success(response) {
    return { type: ic.SET_DEFAULT_VIRTUAL_MEET_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.SET_DEFAULT_VIRTUAL_MEET_FAILURE, error }
  }
}

function getActiveIntegrations(organizationId, usage) {
  return (dispatch) => {
    dispatch(request(organizationId, usage))

    integrationService.getActiveIntegrations(organizationId, usage).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.GET_ACTIVE_DEFAULT_CONNS_REQUEST, response }
  }
  function success(response) {
    return { type: ic.GET_ACTIVE_DEFAULT_CONNS_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.GET_ACTIVE_DEFAULT_CONNS_FAILURE, error }
  }
}

function getAllActiveIntegrations(organizationId, isRefresh) {
  return (dispatch) => {
    dispatch(request())

    integrationService.getActiveIntegrations(organizationId, 'all').then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.GET_ALL_ACTIVE_CONNS_REQUEST, response }
  }
  function success(response) {
    return { type: ic.GET_ALL_ACTIVE_CONNS_SUCCESS, response, isRefresh }
  }
  function failure(error) {
    return { type: ic.GET_ALL_ACTIVE_CONNS_FAILURE, error }
  }
}

function revokeToken(type, usage, organizationId, authToken, isDefault, makeDefaultCallback) {
  return (dispatch) => {
    dispatch(request())

    integrationService.revokeToken(type, organizationId, authToken).then(
      (response) => {
        if (makeDefaultCallback && isDefault) {
          makeDefaultCallback(type, usage, authToken)
        }
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.REVOKE_TOKEN_REQUEST, response }
  }
  function success(response) {
    return { type: ic.REVOKE_TOKEN_SUCCESS, response, authToken }
  }
  function failure(error) {
    return { type: ic.REVOKE_TOKEN_FAILURE, error }
  }
}

function postEventToCalendar(eventId, type, idExternalApiAuth, recurrenceUpdate) {
  return (dispatch) => {
    dispatch(request(eventId, type, idExternalApiAuth, recurrenceUpdate))

    generalService.postEventToCalendar(eventId, type, idExternalApiAuth, recurrenceUpdate).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(eventId, calendarType) {
    return { type: ic.POST_EVENT_TO_CAL_REQUEST, eventId, calendarType, recurrenceUpdate }
  }
  function success(response) {
    return { type: ic.POST_EVENT_TO_CAL_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.POST_EVENT_TO_CAL_FAILURE, error }
  }
}

function addToCalendarWithoutConnection(mixrId, calendarType, mixrRecurrenceRule) {
  return (dispatch) => {
    dispatch(request({ mixrId, calendarType, mixrRecurrenceRule }))

    generalService.addToCalendarWithoutConnection(mixrId, calendarType, mixrRecurrenceRule).then(
      (response) => {
        dispatch(success(response, calendarType))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.ADD_TO_CALENDER_REQUEST, response }
  }
  function success(response, calendarType) {
    if (calendarType === 'google') {
      const updatedResponse = { calendarType, ...response }
      return { type: ic.ADD_TO_CALENDER_SUCCESS, updatedResponse }
    } else {
      const updatedResponse = { calendarType, response: response.toString() }
      return { type: ic.ADD_TO_CALENDER_SUCCESS, updatedResponse }
    }
  }
  function failure(error) {
    return { type: ic.ADD_TO_CALENDER_FAILURE, error }
  }
}

function updateIntegrations(organizationId, externalApiType, usage, action, key) {
  return (dispatch) => {
    dispatch(request({ externalApiType, usage, action }))
    integrationService.updateIntegration(organizationId, externalApiType, usage, action, key).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.UPDATE_INTEGRATION_REQUEST, response }
  }
  function success(response) {
    return { type: ic.UPDATE_INTEGRATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.UPDATE_INTEGRATION_FAILURE, error }
  }
}

function setGoogleTranslationKey(organizationId, key) {
  return (dispatch) => {
    dispatch(request())

    integrationService.setGoogleTranslationKey(organizationId, key).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: ic.SET_GOOGLE_TRANSLATION_REQUEST, response }
  }
  function success(response) {
    return { type: ic.SET_GOOGLE_TRANSLATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: ic.SET_GOOGLE_TRANSLATION_FAILURE, error }
  }
}

function openCalendarModal(mixrId, recurrenceUpdate) {
  return { type: ic.OPEN_MODAL, mixrId, recurrenceUpdate }
}

function closeCalendarModal() {
  return { type: ic.CLOSE_MODAL }
}

function clearData() {
  return { type: ic.CLEAR_DATA }
}
